import React from 'react';
import { createHashRouter, createBrowserRouter, createMemoryRouter } from 'react-router';

import HomeView from './views/home/home';
import ExchangeView from './views/exchange/exchange';
import ExchangeProductSelectionView from './views/exchange/exchange-product-selection';
import ExchangeShippingMethodView from './views/exchange/exchange-shipping-method';
import ExchangeRefundSelectionView from './views/exchange/exchange-refund-selection';
import ExchangeConfirmationView from './views/exchange-confirmation/exchange-confirmation';
import DropOffLocations from './views/exchange/drop-off-locations';
import ReviewExchangeView from './views/exchange/review-exchange';
import ErrorDisplay from './components/error-display/error-display';
import QRCodeView from './views/qrcode/qrcode';

// Stryker disable all
const {
  SITE_BASENAME,
} = process.env;

export const routes = Object.freeze([
  {
    path: '/store/:storeId',
    element: <HomeView />,
    errorElement: <ErrorDisplay />,
  },
  {
    path: '/',
    element: <HomeView />,
    errorElement: <ErrorDisplay />,
  },
  {
    element: <ExchangeView />,
    errorElement: <ErrorDisplay />,
    children: [
      {
        path: '/store/:storeId/exchange/:orderId',
        element: <ExchangeProductSelectionView />,
        errorElement: <ErrorDisplay />,
      },
      {
        path: '/store/:storeId/exchange/:orderId/location',
        element: <ExchangeShippingMethodView />,
        errorElement: <ErrorDisplay />,
      },
      {
        path: '/store/:storeId/exchange/:orderId/refund-method',
        element: <ExchangeRefundSelectionView />,
        errorElement: <ErrorDisplay />,
      },
      {
        path: '/store/:storeId/exchange/:orderId/review',
        element: <ReviewExchangeView />,
        errorElement: <ErrorDisplay />,
      },
      {
        path: '/store/:storeId/exchange/:orderId/drop-off-locations',
        element: <DropOffLocations />,
        errorElement: <ErrorDisplay />,
      },
    ],
  },
  // NOTE: we need to revisit this route. If a customer refreshes the page this
  // route will be executed
  {
    path: '/store/:storeId/exchange/:orderId/confirmation',
    element: <ExchangeConfirmationView />,
    errorElement: <ErrorDisplay />,
  },
  {
    path: '/qrcode',
    element: <QRCodeView />,
    errorElement: <ErrorDisplay />,
  },
], {
  basename: SITE_BASENAME,
});

// Stryker restore all
export function makeHashRouter() {
  return createHashRouter(routes);
}

export function makeBrowserRouter() {
  return createBrowserRouter(routes);
}

export function makeMemoryRouter() {
  return createMemoryRouter(routes);
}
